import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWave } from "@/hooks/useWave";
import { MemesWaveSmallLeaderboardDrop } from "./MemesWaveSmallLeaderboardDrop";
import { DefaultWaveSmallLeaderboardDrop } from "./DefaultWaveSmallLeaderboardDrop";
interface WaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
  readonly onDropClick: () => void;
}
export const WaveSmallLeaderboardDrop: React.FC<WaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(6);
  const {
    drop,
    wave,
    onDropClick
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t1;
    if ($[0] !== drop || $[1] !== onDropClick) {
      t1 = <MemesWaveSmallLeaderboardDrop drop={drop} onDropClick={onDropClick} />;
      $[0] = drop;
      $[1] = onDropClick;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== drop || $[4] !== onDropClick) {
    t1 = <DefaultWaveSmallLeaderboardDrop drop={drop} onDropClick={onDropClick} />;
    $[3] = drop;
    $[4] = onDropClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};